import { AnimatePresence, motion } from "motion/react";
import styles from "./styles.module.css";
import { ArrowUp } from "lucide-react";
import { useCallback } from "react";

interface ScrollIndicatorProps {
  visible: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
}

export default function ScrollIndicator({ visible, containerRef }: ScrollIndicatorProps) {
  const handleScrollToTop = useCallback(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [containerRef.current]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="button"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          className={styles.scrollIndicatorContainer}
          onClick={handleScrollToTop}
        >
          <ArrowUp />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
